var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({attrs:{"disabled":_vm.buttonDisabled},on:{"click":_vm.click},scopedSlots:_vm._u([{key:"loader",fn:function(){return [_vm._t("loader")]},proxy:true}],null,true)},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }